
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/notifications",
      function () {
        return require("private-next-pages/account/notifications.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/notifications"])
      });
    }
  